import { Fragment } from 'react';
import { Helmet } from 'react-helmet';

const timeStamp: Date = new Date();

const Head = () => (
  <Fragment>
    <Helmet>
      <html lang="en" />
      <meta name="wiw-auth-date" content={ timeStamp.toString() } />
      <link rel="preload" href="/font/SourceSansPro-Light.woff2" as="font" type="font/woff2" crossOrigin="anonymous" />
      <link rel="preload" href="/font/SourceSansPro-Regular.woff2" as="font" type="font/woff2" crossOrigin="anonymous" />
      <link rel="preload" href="/font/SourceSansPro-SemiBold.woff2" as="font" type="font/woff2" crossOrigin="anonymous" />
      {process.env.GATSBY_DEPLOY_ENV === 'staging' || process.env.GATSBY_DEPLOY_ENV === 'acceptance' ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : null}
    </Helmet>
  </Fragment>
);

export default Head;
